import { useRef, memo } from 'react';
import SettingsIcon from '@mui/icons-material/Settings';
import { NoImage as NoImageIcon } from "../../../../../assets/NoImage";
import { CardData } from '../../../../../types';

interface ImageUploaderProps {
    cardNum: 1 | 2;
    image: string | null;
    disabled: boolean;
    onChange: (cardNum: 1 | 2, field: keyof CardData, value: any) => void;
    onImageUpload: (e: React.ChangeEvent<HTMLInputElement>, cardNum: 1 | 2) => void;
    uploading: boolean;
    onRemoveImage: (cardNum: 1 | 2) => void;
    onOpenImageConfig: (cardNum: 1 | 2) => void;
}

export const ImageUploader = memo(({
    cardNum,
    image,
    disabled,
    onChange,
    onImageUpload,
    uploading,
    onRemoveImage,
    onOpenImageConfig,
}: ImageUploaderProps) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleLocalImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        onImageUpload(e, cardNum);
    };

    return (
        <div className="image-section">
            <div className="label-row">
                <h5>Image</h5>
                <span className="image-specs">1000x1000 px max - JPG/PNG</span>
            </div>
            <div className="image-uploader" id={`card-${cardNum}-image-section`}>
                {image ? (
                    <div className="image-preview-wrapper" style={{ opacity: uploading ? 0.5 : 1 }}>
                        <img src={image} alt="Card preview" />
                        <button
                            type="button"
                            className="gear-overlay"
                            onClick={() => onOpenImageConfig(cardNum)}
                            disabled={disabled || uploading}
                            title="Image settings"
                        >
                            <SettingsIcon className="settings-icon" />
                        </button>
                    </div>
                ) : (
                    <div className="image-placeholder">
                        <NoImageIcon />
                        <span className="upload-text">{uploading ? 'Uploading...' : 'Upload Image'}</span>
                    </div>
                )}
                <div className="image-actions">
                    <input
                        type="file"
                        id={`image-upload-${cardNum}`}
                        ref={fileInputRef}
                        onChange={handleLocalImageUpload}
                        accept="image/*"
                        className="hidden-input"
                        disabled={disabled || uploading}
                    />

                    <div className="uploaderControl">
                        <label htmlFor={`image-upload-${cardNum}`} className={`btnUpload ${disabled || uploading ? 'disabled' : ''}`} aria-label="Upload">
                            <span className="icoUpload" aria-hidden="true" />
                        </label>
                        <label htmlFor={`image-upload-${cardNum}`} className="uploadText">{uploading ? 'Uploading...' : 'Upload'}</label>
                    </div>

                    <div className="uploaderControl">
                        <button
                            type="button"
                            className="btnRemove"
                            onClick={() => onRemoveImage(cardNum)}
                            disabled={disabled}
                            aria-label="Remove image"
                        >
                            <span className="icoTrash" />
                        </button>
                        <span>Remove</span>
                    </div>
                </div>
            </div>
        </div>
    );
});
